import { requestJson } from '../api/http';
import { agentListResponseSchema, type AgentListResponse } from './schema';

/** `GET /agents` - whether Excel delivery is currently available, for the stale-agent
 * indicator on the note list (`docs/implementation/06-mobile-web.md` 6.3). Resolution of a
 * revoked or offline agent is out of scope here; this only reports. */
export function fetchAgentStatus(): Promise<AgentListResponse> {
  return requestJson('/agents', agentListResponseSchema);
}
